import api from './clients';
import { Compra, CompraFormData, CompraStats } from '../types/compra';

export const comprasApi = {
  getAll: async (params?: any): Promise<Compra[]> => {
    const response = await api.get('/compras', { params });
    return response.data?.data || [];
  },

  getById: async (id: number): Promise<Compra> => {
    const response = await api.get(`/compras/${id}`);
    return response.data?.data;
  },

  create: async (data: CompraFormData): Promise<Compra> => {
    const response = await api.post('/compras', data);
    return response.data?.data;
  },

  update: async (id: number, data: Partial<CompraFormData>): Promise<Compra> => {
    const response = await api.put(`/compras/${id}`, data);
    return response.data?.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/compras/${id}`);
  },

  getStats: async (): Promise<CompraStats> => {
    const response = await api.get('/compras/estadisticas');
    return response.data?.data;
  },

  generatePDF: async (id: number): Promise<{
    numeroCompra: string; pdfUrl: string 
}> => {
    const response = await api.post(`/compras/${id}/pdf`);
    return response.data?.data;
  },
};